import { useEffect, useState } from "react";
import { ChatWindow } from "./ChatWindow";
import { ConversationsSidebar } from "./ConversationSidebar";
import { useSingleUserController } from "../../../controllers/useSingleUserController";
import { useGetRolePermissionsQuery } from "../../../redux/services/staffApi";

const ChatSupport = () => {
    const [selectedDetails, setSelectedDetails] = useState<any>(null);
    
     useEffect(() => {
       // user entered messages module
       localStorage.setItem("in_chat_support", "true");

       return () => {
         // user left messages module
         localStorage.removeItem("in_chat_support");
       };
     }, []);

  return (
    <div className="flex h-[70vh] w-full max-w-full bg-[#F5F6FA]  rounded-[8px] shadow-lg overflow-hidden mt-6 border border-[#BDBDBD] mb-4">
      <div
        className={`
          w-full lg:w-1/3
          ${selectedDetails ? "hidden lg:block" : "block"}
        `}
      >
        <ConversationsSidebar
          loading={false}
          conversations={[]}
          selectedConversationId={null}
          onSelectConversation={(id: string) => {}}
          onSelectDetails={(staff: any) => setSelectedDetails(staff)}
        />
      </div>
      
      {/* Chat Window Component can be added here */}
      <ChatWindow selectedDetails={selectedDetails} onBack={() => setSelectedDetails(null)} />
    </div>
  );
};

export default ChatSupport;
